import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-nav-32",
  "use": "icon-icon-nav-32-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-nav-32\"><path d=\"M806.4 291.2H512L438.4 217.6H217.6c-40.448 0-73.6 33.152-73.6 73.6v441.6c0 40.512 33.152 73.6 73.6 73.6h588.8c40.512 0 73.6-33.152 73.6-73.6V364.8c0-40.512-33.152-73.6-73.6-73.6z m-75.776 404.8l-108.224-63.296-108.16 63.296 28.672-122.56-95.36-82.432 125.504-10.688 49.344-115.52 49.28 115.52 125.504 10.688-95.296 82.432 28.672 122.56z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-nav-32.svg
// module id = bLm/
// module chunks = 3